// ============================================================
// flushAllAutoSaves.ts — persist every pending autosave (case, client,
// client notes, witnesses, deadlines) before a navigation that closes or
// replaces the open record. Same set the sidebar / header nav flush;
// allSettled so one failing save never blocks the navigation (each hook
// keeps its own error + retry state).
// ============================================================
import { flushLiveDocSnapshots } from '../components/shared/liveDocFlush'
import { flushAutoSave } from './useAutoSave'
import { flushClientAutoSave } from './useClientAutoSave'
import { flushClientNotesAutoSave } from './useClientNotesAutoSave'
import { flushWitnessAutoSave } from './useWitnessAutoSave'
import { flushDeadlineAutoSave } from './useCaseDeadlineAutoSave'

export const flushAllAutoSaves = async (): Promise<void> => {
  // ★ (Audit) Push every mounted live-doc editor's debounced HTML copy first
  // (flushSync) — otherwise its teardown flush ran after the store switched
  // records and the case-snapshot guard dropped it (stale HTML copy / PDF).
  await flushLiveDocSnapshots()
  await Promise.allSettled([flushAutoSave(), flushClientAutoSave(), flushClientNotesAutoSave(), flushWitnessAutoSave(), flushDeadlineAutoSave()])
}
